import TemperatureInsight from "./TemperatureInsight";

export default class HottestDay extends TemperatureInsight {
  temperatureType(): string {
    return 'hottest';
  }
}
